import React, { useRef } from 'react'
import { StyleSheet, SafeAreaView, ScrollView, View } from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'

import Calendar from '../Calendar'
import EventsDayTimeline from '../EventsDayTimeline'
import { IconButton, Modal, Txt } from '../../../../components'
import { TouchableOpacity } from 'react-native-gesture-handler'

const EventsModal = (props) => {
  const {
    open,
    date,
    events,
    filteredEvents,
    onClose,
    onChangeDate
  } = props

  const onBackToToday = () => onChangeDate(new Date())
  const today = useRef(moment(new Date(), 'YYYY/MM/DD').format('YYYY-MM-DD'))
  const isCurrentDay = today.current === date

  return (
    <Modal
      modalContainer={styles.modalContainer}
      open={open}
      hideArrow
    >
      <SafeAreaView>
        <View
          style={styles.header}
        >
          <IconButton
            icon='LeftArrow'
            onPress={onClose}
            color='GALLERY'
            iconColor='SLATE_GRAY_TEXT'
            size={30}
            iconSize={16}
          />
          {!isCurrentDay && (
            <TouchableOpacity activeOpacity={0.8} onPress={onBackToToday}>
              <Txt
                text='Back to today'
                identity='body2'
                style={styles.backToToday}
                color='LOCHMARA'
              />
            </TouchableOpacity>
          )}
        </View>
        <ScrollView>
          <View style={{ zIndex: 4 }}>
            <Calendar
              events={events}
              noShadow
              currentDate={date}
              onChangeDate={onChangeDate}
            />
          </View>
          <EventsDayTimeline
            events={filteredEvents}
            date={date}
          />
        </ScrollView>
      </SafeAreaView>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modalContainer: {
    flex: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 10,
    marginHorizontal: 20
  }
})

EventsModal.propTypes = {
  open: PropTypes.bool,
  date: PropTypes.string,
  events: PropTypes.array,
  filteredEvents: PropTypes.array,
  onClose: PropTypes.func,
  onChangeDate: PropTypes.func
}

EventsModal.defaultProps = {
  open: false,
  date: '',
  events: [],
  filteredEvents: [],
  onClose: () => {},
  onChangeDate: () => {}
}

export default EventsModal
